import React,{useState,useEffect} from 'react'
import "./ImportFileform.css"
import download_template from '../../../assets/reUsableTemplates_assets/download_template.png';
import file_upload_icon from '../../../assets/reUsableTemplates_assets/file_upload_icon.png';
import file_uploaded_icon from '../../../assets/reUsableTemplates_assets/file_uploaded_icon.png';
import into from '../../../assets/reUsableTemplates_assets/into.png';


function ImportFileform({filestemp, title, handleFileUpload ,setFiledata,File}) {
  const [file, setFile] = useState(null);
  const [dragActive, setDragActive] = useState(false);

  
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if(selectedFile === undefined){
      setFile(null);
      setFiledata(null);
      return;

    }else{
      if (!selectedFile.name.match(/\.(xls|xlsx)$/i)) {
        if(selectedFile !== undefined){
          alert("Only Excel files are allowed");
        }
        return;
      }else{
        setFiledata(selectedFile);
        setFile({
          name: selectedFile.name,
          size: (selectedFile.size / (1024 * 1024)).toFixed(2) + " MB",
        });
        e.target.value = "";
      }

    }
  };
  const removeFile = () => {
    setFile(null);
    setFiledata(null);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const droppedFile = e.dataTransfer.files[0];
      if (!droppedFile.name.match(/\.(xls|xlsx)$/i)) {
        alert("Only Excel files are allowed");
        return;
      }else{
        setFile(droppedFile);
      setFiledata(droppedFile);
        setFile({
          name: droppedFile.name,
          size: (droppedFile.size / (1024 * 1024)).toFixed(2) + " MB",
        });
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault(); 
    if (!file) {
      alert("no file");
      return;
    }else{
      handleFileUpload()
    }
  };
  useEffect(()=>{
    if(File === null){
      setFile(File);
    }
  },[File]) 
  return (
    
    <div className="container-fluid FormsImportFile-main ">
        <div>
            <div className="row">
                <div className="col-md-12 d-flex FormsImportFile-title">
                    <div className="col ">
                    <h5>Import {title}</h5>
                    <p className='p-0 m-0'>Add your documents here</p>
                    </div>
                    <div className="col"><a href={filestemp} download={ title === "Org. Details" ? "Org_Details":title} className='float-end template-btn'><img src={download_template} alt="" /><span>Template</span></a></div>

                </div>
            </div>
    
            <form onSubmit={handleSubmit}>
              <div className="row FormsImportFile-upload">
                <div className="upload-box-main ">
                  <div
                    className={`upload-box d-flex align-items-center justify-content-between ${
                      dragActive ? "drag-active" : ""
                    }`}
                    onDragOver={(e) => {
                      e.preventDefault();
                      setDragActive(true);
                    }}
                    onDragLeave={() => setDragActive(false)}
                    onDrop={handleDrop}
                  >
                    <div className="d-flex align-items-center">
                      <div className="upload-icon me-2">
                        <img src={file_upload_icon} alt="no img" />
                      </div>
                      <div>
                        <p className="p-0 m-0">
                          {dragActive ? "Drop file here" : "Select a file or drag and drop here"}
                        </p>
                        <small className="text-muted">
                          Only supports .xlsx
                        </small>
                      </div>
                    </div>
                    <a
                      onClick={() => document.getElementById("fileInput").click()}
                    >
                      SELECT FILE
                    </a>
                    <input
                      type="file"
                      id="fileInput"
                      className="d-none"
                      onChange={handleFileChange}
                      accept=".xls,.xlsx"
                    />
                  </div>
                </div>

                {file && (
                  <div className="uploaded-box-main p-0 m-0">
                    <div className="uploaded-file d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <img src={file_uploaded_icon} alt="no img" />
                        <div>
                          <p className="mb-0 uploaded-file-name">{file.name}</p>
                          <small className="text-muted uploaded-file-size">{file.size}</small>
                        </div>
                      </div>
                      <a
                        className="close-btn p-0"
                        onClick={removeFile}
                      >
                        <img src={into} alt="noImg" />
                      </a>
                    </div>
                  </div>
                )}

                <div className="col-12 mt-3">
                  <button className="upload-file-submit-btn">Submit</button>
                </div>
              </div>
            </form>
        </div>
    </div>
  )
}

export default ImportFileform